import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/campTypes/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/campTypes/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/campTypes/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/campTypes/delete',
    method: 'post',
    data
  })
}

